<main class="container-fluid">
  <section class="sec-main d-flex align-items-center">
    <article class="row">
      <div class="col offset-md-4 offset-1">
        <p>COIL DATA ON DEMAND</p>
        <h1 class="heading">Coil data for better decisions and increased efficiency</h1>
        <div class="mt-5">
          <button class="btn btn-primary px-4" (click)="navigateToForm()">Get Started</button>
        </div>
      </div>
    </article>
  </section>
  <section class="sec-pp row">
    <article class="col offset-1">
      <div class="row">
        <div class="col align-self-center py-5">
          <h3 class="heading">Instant access</h3>
          <p class="para-text">We eliminate the need for manual data requests and reduce lead times by providing you with direct access to coil data. Empower your operations with instant insights, anywhere, at any time.</p>
          <div class="mt-5">
            <button class="btn btn-primary px-4" (click)="navigateToForm()">Request a demo</button>
          </div>
        </div>
        <div class="col d-sm-none d-md-inline">
          <img src="assets/images/landing-poss.png" alt="">
        </div>
      </div>
    </article>
  </section>
  <section class="sec-analytics row">
    <article class="col offset-1 offset-md-0">
      <div class="row">
        <div class="col d-sm-none d-md-inline">
          <img src="assets/images/landing-search-result.png" alt="Searhing">
        </div>
        <div class="col align-self-center justify-content-sm-center py-5">
          <h3 class="heading">Increased efficiency</h3>
          <p class="para-text">Optimize your processes and increase efficiency with detailed thickness and width plots. Align your production and streamline your workflow with coil data to boost speed and improve quality.</p>
          <div class="mt-5">
            <button class="btn btn-primary px-4" (click)="navigateToForm()">Request access</button>
          </div>
        </div>
      </div>
    </article>
  </section>
  <section class="sec-pp row">
    <article class="col offset-1">
      <div class="row">
        <div class="col align-self-center py-5">
          <h3 class="heading">Informed decisions</h3>
          <p class="para-text">Want to evaluate customer requests intelligently? Make informed decisions based on coil analytics, ensuring customer satisfaction and effective stock management.</p>
          <div class="mt-5">
            <button class="btn btn-primary px-4" (click)="navigateToForm()">Contact us</button>
          </div>
        </div>
        <div class="col d-sm-none d-md-inline">
          <img src="assets/images/landing-precision.png" alt="Graphs">
        </div>
      </div>
    </article>
  </section>
  <section class="sec-footer d-flex justify-content-around">
    <article>
        <div class="row my-5">
          <div class="col-3">
            <ul>
              <li class="mb-2 li-first">About Us</li>
              <li><a href="#">At a galance</a></li>
              <li><a href="#">Our strategy</a></li>
              <li><a href="#">Organisation</a></li>
              <li><a href="#">Our heritage</a></li>
              <li><a href="#">Our people</a></li>
              <li><a href="#">Sites and facilities</a></li>
              <li><a href="#">Innovation</a></li>
              <li><a href="#">Contact us</a></li>
            </ul>
          </div>
          <div class="col-4">
            <ul>
              <li class="mb-2 li-first">Careers</li>
              <li><a href="#">Careers in the UK</a></li>
              <li><a href="#">Careers in the NL</a></li>
              <li><a href="#">Careers in India</a></li>
            </ul>
          </div>
          <div class="col-5">
            <ul>
              <li class="mb-2 li-first">Corporate</li>
              <li><a href="#">Corporate governance</a></li>
              <li><a href="#">Modern slavary</a></li>
              <li><a href="#">Our communities</a></li>
              <li><a href="#">Supply chain transparency</a></li>
              <li><a href="#">Environment</a></li>
              <li><a href="#">Packaging recycling</a></li>
            </ul>
          </div>
        </div>
        <div class="row mx-4">
          <div class="col">
            <p>
              Tata Steel Europe limited
              <br> Registered Office: 18 Grosvenor Place, London, SW1X 7HS
              <br> Registered in England No. 05957565
              <br> Tata Steel &copysr; 2024
            </p>
          </div>
        </div>
    </article>
    <article>
      <div class="row my-5">
        <div class="col-6">
          <ul>
            <li><a href="#">Global site</a></li>
            <li><a href="#">Legal notice</a></li>
            <li><a href="#">Cookies</a></li>
            <li><a href="#">Sales Terms & Conditions</a></li>
            <li><a href="#">Suppliers</a></li>
            <li><a href="#">Health & Safety</a></li>
            <li><a href="#">Logistics</a></li>
            <li><a href="#">Sitemap</a></li>
          </ul>
        </div>
        <div class="col-2"></div>
        <div class="col-2"></div>
        <div class="col-2"></div>
      </div>
    </article>
  </section>
</main>
